// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"i8","loading":"i9","b":"i-","errorMsg":"i_","loadingMsg":"ja","successMsg":"jb","hideLoadingMsg":"jc","completed":"jd","a":"je","kidsGreen":"jf"};